<!-- <template>
  <Dialog :open="isOpen" @close="isOpen = false">
    <DialogPanel>
      <img :src="src" />
    </DialogPanel>
  </Dialog>
</template> -->
<template>
  <TransitionRoot appear :show="isOpen" as="template">
    <Dialog
      as="div"
      :open="isOpen"
      class="relative z-[999]"
      @close="isOpen = false"
    >
      <TransitionChild
        as="template"
        enter="duration-300 ease-out"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="duration-200 ease-in"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <div class="fixed inset-0 bg-black bg-opacity-50" />
      </TransitionChild>

      <div
        class="fixed inset-0 flex h-full w-full items-center justify-center p-4"
      >
        <TransitionChild
          as="template"
          enter="duration-300 ease-out"
          enter-from="opacity-0 scale-95"
          enter-to="opacity-100 scale-100"
          leave="duration-200 ease-in"
          leave-from="opacity-100 scale-100"
          leave-to="opacity-0 scale-95"
        >
          <DialogPanel class="flex h-full bg-white shadow-xl transition-all">
            <UiAsset :asset="src" />
          </DialogPanel>
        </TransitionChild>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script setup lang="ts">
import {
  Dialog,
  DialogPanel,
  TransitionRoot,
  TransitionChild,
} from "@headlessui/vue";

interface ImageData {
  alt?: string;
  url: string;
  type?: string;
}

const props = defineProps<{
  src: ImageData;
  alt?: string;
  modelValue: boolean;
  type?: string;
}>();

const emit = defineEmits(["update:modelValue"]);

const isOpen = computed<boolean>({
  set(val) {
    emit("update:modelValue", val);
  },
  get() {
    return props.modelValue;
  },
});
</script>
